<template>
    <b-modal
        id="add-assignment-skill-tree"
        v-model="display"
        :title="$t('assignment.add_skills_set_to_this_assignment')"
        size="md"
        @ok="onOk"
        hide-footer
        modal-class="apprentice-default-modal add-skill-tree-modal">
        <design-2021-simple-multi-steps-form-component
            ref="multiStepForm"
            :steps="steps"
            @validate-step="validateStep"
            @submit-form="onOk">
            <template #step1>
                <p class="info">
                    {{
                        $t(
                            'assignment.please_note_that_the_student_will_only_see_the_first_rubric_of_the_skill_that_is_chosen',
                        )
                    }}
                </p>
                <b-form-group
                    class="rubric-skill-sets-group"
                    :label="$t('assignment.choose_a_skill_set')">
                    <design-2021-apprentice-multiselect-component
                        v-model="selectedSkillTree"
                        :multiple-select="false"
                        label="name"
                        :options="skillTrees"
                        track-by="id"
                        :placeholder="$t('assignment.choose_a_skill_set')"
                        :show-labels="false">
                    </design-2021-apprentice-multiselect-component>
                </b-form-group>
            </template>

            <template #step2>
                <div class="rubric-survey-settings">
                    <div class="survey-rating-option">
                        <h5 class="title">{{ $t('assignment.peer_feedback') }}</h5>

                        <b-form-group
                            class="survey-rating-option-group"
                            :label="$t('assignment.type_of_assessment')">
                            <b-form-select
                                class="apprentice-primary-select"
                                id="survey-rating-option"
                                v-model="selectedPeerOption"
                                :options="peerOptions">
                            </b-form-select>
                        </b-form-group>

                        <b-form-group
                            class="max-peer-rating-option-group"
                            v-if="selectedPeerOption !== null"
                            :label="$t('assignment.amount_of_fellow_students')"
                            label-for="max-peer-rating-option-input">
                            <b-form-input
                                class="apprentice-primary-input"
                                id="max-peer-rating-option-input"
                                v-model="peer_amount"
                                type="number"
                                min="0"
                                :max="groupIn.student_amount">
                            </b-form-input>
                        </b-form-group>
                    </div>

                    <div class="survey-choose-teacher">
                        <h4 class="title">{{ $t('assignment.choose_teacher') }}</h4>
                        <b-form-group
                            class="survey-choose-teacher-group"
                            :label="$t('assignment.select_teachers_here')">
                            <design-2021-apprentice-multiselect-component
                                id="survey-choose-teacher-selects"
                                v-model="selectedTeachers"
                                label="full_name"
                                :allow-empty="true"
                                :options="teachers"
                                track-by="id">
                            </design-2021-apprentice-multiselect-component>
                        </b-form-group>
                    </div>
                </div>
            </template>
        </design-2021-simple-multi-steps-form-component>
    </b-modal>
</template>

<script>
import $ from 'jquery';

export default {
    name: 'design-2021-assignment-edit-skill-tree-modal-component',
    props: {
        groupIn: {
            type: Object,
        },
        assignmentIn: {
            type: Object,
        },
    },
    data() {
        return {
            display: false,
            skillTrees: [],
            steps: [
                { step_no: 1, step_valid: false, step_skip: false },
                { step_no: 2, step_valid: false, step_skip: true },
            ],
            loaded: false,
            rubricData: [],
            selectedSkillTree: null,
            selectedPeerOption: null,
            peerOptions: [
                { text: this.$t('assignment.students_do_not_assess_each_other'), value: null },
                { text: this.$t('assignment.student_chooses_fellow_student'), value: 1 },
                { text: this.$t('assignment.the_system_automatically_chooses_fellow_student'), value: 2 },
            ],
            peer_amount: 1,
            teachers: [],
            selectedTeachers: [],
        };
    },
    methods: {
        show() {
            this.display = true;
            if (this.assignmentIn.assignment_skill_tree) {
                this.selectedSkillTree = this.assignmentIn.assignment_skill_tree.skill_tree;
                this.selectedPeerOption = this.assignmentIn.assignment_skill_tree.peer_option;
                this.peer_amount = this.assignmentIn.assignment_skill_tree.peer_amount;
            }
            axios.get(this.routes.getRubricSurvey()).then(
                (response) => {
                    this.skillTrees = response.data.skillTrees;
                    this.teachers = response.data.teachers;
                    this.loaded = true;
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        validateStep(stepIndex) {
            switch (stepIndex) {
                case 0:
                    this.validateFirstStep(stepIndex);
                    break;

                default:
                    this.validatedStep(stepIndex);
            }
        },
        validateFirstStep(stepIndex) {
            if (!this.selectedSkillTree) {
                return;
            }

            this.validatedStep(stepIndex);
        },

        validatedStep(stepIndex) {
            this.steps[stepIndex].step_valid = true;
            this.$refs.multiStepForm.nextStep();
        },
        onOk(bvModalEvt) {
            let teacherIds = this.selectedTeachers.map((teacher) => teacher.id);

            let data = {
                group_id: this.groupIn.id,
                peer_option: this.selectedPeerOption,
                peer_amount: this.selectedPeerOption ? this.peer_amount : null,
                skill_tree_id: this.selectedSkillTree.id,
                teacher_ids: teacherIds,
            };
            this.alert.saving();
            if (this.assignmentIn.assignment_skill_tree) {
                this.axios
                    .post(this.routes.assignmentSkillTreeUpdate(this.assignmentIn.id, this.groupIn.id), data)
                    .then((response) => {
                        this.$emit('skill-tree-changed', response.data);
                        this.alert.success();
                        this.display = false;
                    });
            } else {
                this.axios.post(this.routes.assignmentSkillTree(this.assignmentIn.id, this.groupIn.id), data).then(
                    (response) => {
                        this.$emit('skill-tree-changed', response.data);
                        this.alert.success();
                        this.display = false;
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    },
                );
            }
        },
    },
};
</script>

<style scoped lang="scss">
.info,
.description {
    margin-bottom: $grid-gutter-width;
    color: $text-muted-color;
    line-height: 1.5;
    font-size: $base-font-size;
}
</style>
